import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=5e6e1906&scoped=true&"
import script from "./Group.vue?vue&type=script&lang=ts&"
export * from "./Group.vue?vue&type=script&lang=ts&"
import style0 from "./Group.vue?vue&type=style&index=0&id=5e6e1906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6e1906",
  null
  
)

export default component.exports